import { useQuery } from "@tanstack/react-query";
import { vehiclesLookupMapToSelectItems } from "../handlers";
import { getVehiclesLookup } from "../services";

export const useGetVehiclesLookup = (isOpen = true) =>
	useQuery({
		queryKey: ["vehicles-lookup"],
		queryFn: () => getVehiclesLookup(),
		select: (data) => vehiclesLookupMapToSelectItems(data),
		enabled: !!isOpen,
		staleTime: 1000 * 60 * 15, // 15 minutes,
	});
